"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var mod = function (n, m) {
    return ((n % m) + m) % m;
};
exports.default = mod;
//# sourceMappingURL=mod.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/mod.js
// module id = 1136
// module chunks = 37